<div class="position-reletivediv">
    <div class="popup-inner-space">
      <div class="text-right flow-right">
        <img src="assets/images/close.svg" id="close" alt="..." class="img-fluid closeicon2 cursor-pointer" (click)="Close();">
      </div>
    </div>
    <form [formGroup]="DashbaordConfigDataForm" (ngSubmit)="SaveDashboard()" id="adddashboard" class="popup-inner-space">
      <div class="container-data56 popup-inner-space">
        <div class="errmsg error-fix" *ngIf="errorMsg">{{errorMsg}}</div>
    </div>
      <div class="fxg-field input-field-w input-field-sigiup">
        <div class="fxg-field  margin-top-20 email-field-space">
          <input formControlName="DashboardName" id="DashboardName" class="fxg-field__input-text fxg-field__input--required sessioncamexclude">
          <span class="fxg-field__placeholder fxg-field__floating-placeholder"
          tabindex="-1" (keyup)="CheckDashboardNameExist()">Dashboard Name</span>
          <div class="main-errormsg" *ngIf="displayMessage.DashboardName">
            {{displayMessage.DashboardName}}
          </div>
        </div>
      </div>
      <div class="text-right margin-top-20">
        <button class="btncommon" type="submit" id="send">Save</button>
      </div>
    </form>
  